/**
 * FilterBar Component
 *
 * Reusable filter/search bar with search input and action buttons.
 */

import React from "react";
import { commonStyles, colors } from "../styles";

const FilterBar = ({ children }) => (
  <div style={commonStyles.filterBar}>{children}</div>
);

/**
 * SearchInput Component
 *
 * Search input field with consistent styling
 */
export const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  type = "text",
  style = {},
}) => (
  <div style={{ flex: 1, minWidth: "200px", maxWidth: "400px", ...style }}>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={commonStyles.input}
    />
  </div>
);

/**
 * StatusSelect Component
 *
 * Dropdown for filtering by status
 */
export const StatusSelect = ({ value, onChange, options }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    <label
      style={{
        fontSize: "13px",
        fontWeight: 600,
        color: colors.primary,
      }}
    >
      Status:
    </label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        padding: "10px 36px 10px 14px",
        border: `1px solid ${colors.gray400}`,
        borderRadius: "4px",
        fontSize: "14px",
        background: colors.white,
        cursor: "pointer",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        backgroundImage:
          "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%232e3b61' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 10px center",
        backgroundSize: "16px",
        minWidth: "120px",
      }}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

/**
 * ResultsBadge Component
 *
 * Badge showing number of results
 */
export const ResultsBadge = ({ showing, total }) => (
  <span
    style={{
      padding: "8px 16px",
      background: colors.primary,
      color: colors.white,
      borderRadius: "20px",
      fontSize: "13px",
      fontWeight: 600,
    }}
  >
    Showing {showing} of {total} results
  </span>
);

export default FilterBar;
